// extracted by mini-css-extract-plugin
module.exports = {"formControl":"CustomerNumberSelect_formControl__1J5Y4","spacer":"CustomerNumberSelect_spacer__3UGfI","loading":"CustomerNumberSelect_loading__2y4rY"};